// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wAB1","colBig":"styles_colBig__sS0do","colSmall":"styles_colSmall__2ieLS"};